export default __webpack_public_path__ + "static/media/wi_13d_snow.f100010e.svg";